import { Service } from '../../domain/entities/Service.entity';
import { InvalidServiceError } from '../../domain/errors/InvalidServiceError';
import type { ServicesRepository } from '../../domain/repositories/ServicesRepository.interface';
import type { ServiceDto } from '../dto/ServiceDto';
import { ApplicationError, type Logger } from '@dma/shared';

export class GetServicesUseCase {
  constructor(
    private readonly repository: ServicesRepository,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<ServiceDto[]> {
    try {
      const services = await this.repository.getAll();
      return services.map((service) => service.props);
    } catch (error) {
      if (error instanceof InvalidServiceError) {
        this.logger.error('Services content failed domain validation', {
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('SERVICES_UNAVAILABLE', 'فهرست خدمات در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
